import { render, staticRenderFns } from "./NotEnoughBalanceNoticeModal.vue?vue&type=template&id=e770d36c&scoped=true&"
import script from "./NotEnoughBalanceNoticeModal.vue?vue&type=script&lang=js&"
export * from "./NotEnoughBalanceNoticeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e770d36c",
  null
  
)

export default component.exports